import { Button, FormLabel, Image, Input, useToast } from '@chakra-ui/react'
import { useGoogleLogin } from '@react-oauth/google'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import AuthService from '../../services/Auth/AuthService'
import styles from './Login.module.css'

export default function LoginPage({ refreshUser }: { refreshUser: () => void }) {
  const actualDate = new Date()
  const actualYear = actualDate.getFullYear()
  const [loginError, setLoginError] = useState('')
  const [form, setForm] = useState({ email: '', password: '' })
  const navigate = useNavigate()
  const authService = new AuthService()
  const toast = useToast()
  const [logging, setLogging] = useState(false)

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => makeLogin(codeResponse),
    // eslint-disable-next-line no-console
    onError: (error) => console.error('Login Failed:', error)
  })

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setLogging(true)

    authService
      .auth(form)
      .then((response) => {
        localStorage.setItem('token', response.data.token)
        localStorage.setItem('user', JSON.stringify(response.data.user))

        refreshUser()
        navigate('/home')
      })
      .catch(() => {
        toast({
          title: 'Erro',
          description: 'Falha ao realizar login',
          status: 'error',
          duration: 3000,
          isClosable: true
        })

        setLogging(false)
      })
  }

  const makeLogin = async (response: { access_token: string }) => {
    try {
      setLogging(true)
      const auth = await authService.authGoogle({ access_token: response.access_token })

      localStorage.setItem('token', auth.data.token)
      localStorage.setItem('user', JSON.stringify(auth.data.user))

      refreshUser()
      navigate('/home')
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      setLogging(false)
      setLoginError(e.response.data.error)
    }
  }

  useEffect(() => {
    if (localStorage.getItem('token')) {
      refreshUser()
      navigate('/home')
    } else {
      setLogging(false)
    }
  }, [])

  return (
    <>
      <div className={styles.login}>
        <div className="container min-vh-100 vw-100 d-flex align-items-center justify-content-center flex-column">
          <img src="/img/logo.png" className="d-inline" />
          <form className="w-100 d-flex flex-column align-items-center" onSubmit={handleLogin}>
            <div className="row w-100">
              <div className="col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4 mb-3">
                <div className="form-group">
                  <FormLabel htmlFor="email" color="white">
                    E-mail
                  </FormLabel>
                  <Input
                    placeholder="E-mail"
                    type="email"
                    color="white"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    disabled={logging}
                  />
                </div>
              </div>
              <div className="col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4 mb-3">
                <div className="form-group">
                  <FormLabel htmlFor="password" color="white">
                    Senha
                  </FormLabel>
                  <Input
                    placeholder="Senha"
                    type="password"
                    color="white"
                    value={form.password}
                    onChange={(e) => setForm({ ...form, password: e.target.value })}
                    disabled={logging}
                  />
                </div>
              </div>
              <div className="col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4 mb-2">
                <div className="form-group">
                  <Button colorScheme="magenta" mt={2} type="submit" width="100%" disabled={logging}>
                    Acessar
                  </Button>
                </div>
              </div>
            </div>
          </form>

          <div className="row w-100">
            <div className="col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4">
              <div className="form-group">
                <Button
                  colorScheme="whiteAlpha"
                  mt={2}
                  type="button"
                  onClick={() => login()}
                  variant="outline"
                  width="100%"
                  disabled={logging}
                >
                  <Image src="/img/google-icon.png" alt="Google" width="20px" height="20px" marginEnd={2} />
                  Acessar com o Google
                </Button>
              </div>
            </div>
          </div>
          {loginError && <p className="text-center mt-2 text-white">{loginError}</p>}
        </div>

        <footer className={styles.loginFooter}>
          © {actualYear} All Right Reserved. ABRA - Academia Brasileira de Arte.
        </footer>
      </div>
    </>
  )
}
